import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Label,
  RadioGroup,
  RadioGroupItem,
} from '@packages/ui';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import zod from 'zod';
import { Step } from './Step';
import { useTranslation } from 'react-i18next';

const formSchema = zod.object({
  groom: zod.string().min(2),
  groom_pronoun: zod.enum(['he', 'she', 'they']),
  bride: zod.string().min(2),
  bride_pronoun: zod.enum(['he', 'she', 'they']),
});

type FormData = zod.infer<typeof formSchema>;

type Props = {
  defaultData?: FormData;
  onSubmit: (data: FormData) => void;
  isActive: boolean;
  isDone: boolean;
  onActivate: () => void;
};
export const StepCouple = ({ onSubmit, defaultData, isActive, isDone, onActivate }: Props) => {
  const form = useForm({
    defaultValues: defaultData,
    resolver: zodResolver(formSchema),
  });

  const { t } = useTranslation();

  return (
    <Step
      question={t('whoIsTheHappyCouple')}
      form={form}
      onNext={onSubmit}
      isActive={isActive}
      isDone={isDone}
      onActivate={onActivate}
      autofocusField="groom">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-2">
        <FormField
          control={form.control}
          name="groom"
          render={({ field }) => {
            return (
              <FormItem className="md:col-span-3">
                <FormLabel>{t('groomName')}</FormLabel>
                <FormControl>
                  <Input placeholder="" className="w-full" disabled={!isActive} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            );
          }}
        />
        <FormField
          control={form.control}
          name="groom_pronoun"
          render={({ field }) => {
            return (
              <FormItem className="md:col-span-2">
                <FormLabel>{t('groomPronoun')}</FormLabel>
                <FormControl>
                  <RadioGroup
                    defaultValue={field.value}
                    onValueChange={field.onChange}
                    className="flex pt-3">
                    <RadioGroupItem value="he" id="he" />
                    <Label htmlFor="he" className="hover:cursor-pointer">
                      {t('pronoun.he')}
                    </Label>

                    <RadioGroupItem value="she" id="she" />
                    <Label htmlFor="she" className="hover:cursor-pointer">
                      {t('pronoun.she')}
                    </Label>

                    <RadioGroupItem value="they" id="they" />
                    <Label htmlFor="they" className="hover:cursor-pointer">
                      {t('pronoun.they')}
                    </Label>

                    <RadioGroupItem value="none" id="none" />
                    <Label htmlFor="none" className="hover:cursor-pointer">
                      {t('pronoun.none')}
                    </Label>
                  </RadioGroup>
                </FormControl>
                <FormMessage />
              </FormItem>
            );
          }}
        />
        <FormField
          control={form.control}
          name="bride"
          render={({ field }) => {
            return (
              <FormItem className="mt-6 md:mt-0 md:col-span-3">
                <FormLabel>{t('bridesName')}</FormLabel>
                <FormControl>
                  <Input placeholder="" disabled={!isActive} className="w-full" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            );
          }}
        />
        <FormField
          control={form.control}
          name="bride_pronoun"
          render={({ field }) => {
            return (
              <FormItem className="md:col-span-2">
                <FormLabel>{t('bridesPronoun')}</FormLabel>
                <FormControl>
                  <RadioGroup
                    defaultValue={field.value}
                    onValueChange={field.onChange}
                    className="flex pt-3">
                    <RadioGroupItem value="he" id="he" />
                    <Label htmlFor="he" className="hover:cursor-pointer">
                      {t('pronoun.he')}
                    </Label>

                    <RadioGroupItem value="she" id="she" />
                    <Label htmlFor="she" className="hover:cursor-pointer">
                      {t('pronoun.she')}
                    </Label>

                    <RadioGroupItem value="they" id="they" />
                    <Label htmlFor="they" className="hover:cursor-pointer">
                      {t('pronoun.they')}
                    </Label>

                    <RadioGroupItem value="none" id="none" />
                    <Label htmlFor="none" className="hover:cursor-pointer">
                      {t('pronoun.none')}
                    </Label>
                  </RadioGroup>
                </FormControl>
                <FormMessage />
              </FormItem>
            );
          }}
        />
      </div>
    </Step>
  );
};
